import { motion } from "framer-motion";
import { formatET } from "../../lib/dateUtils";

export function StoreUpdatesFeed({ updates }) {
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.3 }} className="bg-igc-surface border border-igc-gold/15 p-6" data-testid="store-updates-feed">
      <p className="text-igc-muted text-xs uppercase tracking-widest mb-4" title="A running log of important notes and milestones your account team has posted about your store.">Store Updates</p>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {updates.length === 0 && <p className="text-igc-muted text-sm">No updates yet.</p>}
        {updates.map((u) => (
          <div key={u.id} className="border-l-2 border-igc-gold pl-4 py-1" data-testid={`store-update-${u.id}`}>
            <p className="text-igc-muted text-xs mb-1">{formatET(u.timestamp, "MMM d, yyyy")}</p>
            <p className="text-igc-cream text-sm leading-relaxed">{u.text}</p>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
